<lcs-loading-overlay class="flex-dir-col" [show]="callState | lcsCallState : 'loading'">
  <div>
    <div class="compact-register-header flex-container space-between">
      <mat-slide-toggle color="primary" class="toggle-slider" [(ngModel)]="showPastClosedExceptions">
        Show past closed exceptions
      </mat-slide-toggle>
      <div class="ml-auto">
        @if (canEdit) {
          <button
            class="create-btn"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onAddClosedExceptionClick()"
            >Add Closed Exception</button
            >
          }
        </div>
      </div>
      <lcs-responsive-table [columns]="columns">
        <table lcs-table [dataSource]="closedExceptionItems">
          <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
          <tr
            lcs-row
            *lcsResponsiveRowDef="let index = dataIndex"
            [hidden]="closedExceptionItems[index].isDeleted"
          ></tr>
          <ng-container lcsColumnDef="StartDate" width="4">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">Start Date</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ closedExceptionItems[index].startDate | date : 'yyyy-MM-dd' : 'UTC' }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="EndDate" width="4">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">End Date</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ closedExceptionItems[index].endDate | date : 'yyyy-MM-dd' : 'UTC' }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="StartTime" width="4">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">Start Time</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ closedExceptionItems[index].startTime | date : 'hh:mm aa&nbsp;&nbsp;' : 'UTC' }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="EndTime" width="4">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">End Time</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ closedExceptionItems[index].endTime | date : 'hh:mm aa&nbsp;&nbsp;' : 'UTC' }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="Prompt" width="6">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header">Prompt</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex">
              <a>
                {{ closedExceptionItems[index].prompt?.name }}
              </a>
            </td>
          </ng-container>
          <ng-container lcsColumnDef="MoreActions" width="2">
            <th lcs-header-cell *lcsHeaderCellDef id="open-hours-column-header"></th>
            <td lcs-cell *lcsCellDef="let index = dataIndex" class="more-actions-btn"
              >@if (canEdit || canDelete) {
              <button
                type="button"
                aria-label="Closed Exception Actions"
                matTooltip="More Actions"
                mat-icon-button
                [matMenuTriggerFor]="closedExceptionListItemMenu"
                [matMenuTriggerData]="{ $implicit: closedExceptionItems[index], index: index }"
                [disabled]="disabled"
                id="closed-exception-list-option-menu-button-{{ index }}"
                >
                <mat-icon> more_horiz </mat-icon>
              </button>
            }
            <mat-menu #closedExceptionListItemMenu="matMenu">
              <input type="hidden" />
              @if (canEdit) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-edit"
                  (click)="onEditClosedExceptionClick(index)"
                  >
                  Edit
                </button>
              }
              @if (canDelete) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-delete"
                  (click)="onDeleteClick(index)"
                  >
                  Delete
                </button>
              }
              @if (canEdit) {
                <button
                  mat-menu-item
                  type="button"
                  id="menu-copy"
                  (click)="onCopyClosedExceptionClick(index)"
                  >
                  Copy to Other Schedules
                </button>
              }
            </mat-menu></td
            >
          </ng-container>
        </table>
      </lcs-responsive-table>
    </div>
  </lcs-loading-overlay>
